<template>
  <v-dialog v-model="dialog" max-width="650px">
      <template #activator="{on}" v-if="!inventory">
          <v-tooltip top >
            <template #activator="{ on, attrs }">
                <v-btn v-show="!canValidate" outlined  v-on="on" color="grey" v-bind="attrs">Validate</v-btn>
            </template>
            <span>Please select a currency</span>
          </v-tooltip>
          <template >
            <v-btn v-show="canValidate" v-on="on" outlined color="green">Validate</v-btn>
          </template>
      </template>
      <v-card>
          <v-card-title>
              Validate PO ?
          </v-card-title>
          <v-card-text>
              <p>Are you sure do you want validate PO ?</p>
              <p>These products will be added to the incomming list</p>
              <v-simple-table dense>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left">
                                Name
                            </th>
                            <th class="text-left">
                                Quantity
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="line in po.lines"
                            :key="'_line_'+line.id"
                        >
                            <td>{{ line.product.name }}</td>
                            <td>{{ line.quantity }}</td>
                        </tr>
                    </tbody>
                </template>
              </v-simple-table>
          </v-card-text>
          <v-card-actions>
              <v-btn @click="dialog=false">Cancel</v-btn>
              <v-spacer />
              <v-btn @click="validate(false)" color="orange">Validate without mail</v-btn>
              <template v-if="po.supplier.contact_mail">
                <v-spacer/>
                <v-btn @click="validate(true)"  color="green">Validate with mail</v-btn>
              </template>
          </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
export default {
    name: 'PurchaseOrderValidate',
    data: () => ({
        dialog: false,
        validationIssue: null
    }),
    props:{
        po:{
            type:Object,
            required:true
        }
    },
    mounted() {
      this.getInventory()
    },
  computed:{
      ...mapGetters("inventory", {inventory: 'inventory'}),
      canValidate(){
          return !!this.po.currency
      }
    },
    methods:{
        ...mapActions("purchaseOrders",{
            validatePurchaseOrder:'validate',
        }),
        ...mapActions("inventory", { getInventory:"getInventory"}),
        validate(sendMail){
            this.validatePurchaseOrder({poId:this.po.id, sendMail})
            .then(() => {
                this.flashMessage.success({
                    message: "PO validated",
                });
                this.dialog=false;
                this.$emit("validated");
            })
            .catch(({data})=>{
                if(data){
                    this.flashMessage.error({
                        message: data.message
                    });
                }
            })
        },
    }
}
</script>

<style>

</style>